import { currencyRounded } from '@sunbit-dev/common/helpers/numbers';
import ICreditLineDetails from '@sunbit-dev/common/models/cardApply/ICreditLineDetails';
import IDocument from '@sunbit-dev/common/models/IDocument';
import React from 'react';
import styled from 'styled-components';
import AgreeButton from '../../components/agreeButton/AgreeButton';
import CommonSection from '../../components/commonSection/CommonSection';
import SectionTitle from '../../components/sectionTitle/SectionTitle';
import Title from '../../components/title/Title';
import ShowPdfLink, { PDFStrategies } from '../../components/showPdfLink/ShowPdfLink';
import { PrivacyOptions } from '@sunbit-dev/common/enums/Datadog';
import { formatDate } from '@sunbit-dev/common/helpers/dates';

// ############################ Styles ###########################
// tslint:disable:variable-name
const SApprovalTerms = styled.div`
  display: flex;
  flex-direction: column;
`;

const SBold = styled.span(
  ({ theme }) => `
  font-weight: ${theme.font.weight.bold};
`
);

const STitle = styled(Title)(
  ({ theme }) => `
  @media only screen and ${theme.device.max.mobileS}{
  font-size : ${theme.font.size.medium3};
  }
`
);

// tslint:enable:variable-name
// ############################ End Styles ###########################

interface IApprovalTermsProps extends ICreditLineDetails {
  creditScoreNoticeDocument?: IDocument;
  continue: () => void;
}

const getCreditLineValuesPDisplay = (value: number) => parseFloat(value.toFixed(2));
// tslint:disable-next-line:variable-name
const ApprovalTerms: React.FC<IApprovalTermsProps> = (props) => {
  const handleSubmit = React.useCallback(() => {
    props.continue();
  }, []);
  return (
    <SApprovalTerms data-dd-privacy={PrivacyOptions.MaskUserInput}>
      <CommonSection>
        <STitle data-at="congratulations">Congratulations!</STitle>
      </CommonSection>
      <CommonSection>
        <SectionTitle data-at="creditLineText">
          <SBold>
            You&apos;re preliminarily approved for a credit limit of <span data-at="creditLine">{currencyRounded(props.creditLine)}</span> with an APR of{' '}
            <span>{getCreditLineValuesPDisplay(props.apr)}</span>
          </SBold>
          %.
          <br />
          <br />
          (This APR will vary with the market based on the Prime Rate. The Index is <span>{getCreditLineValuesPDisplay(props.primeRate)}%</span> as of <span>{formatDate(props.offerDate)}</span>. If
          the Prime Rate changes before you complete your application, your APR may change.)
        </SectionTitle>
      </CommonSection>
      <CommonSection>
        <ShowPdfLink pdfStrategy={PDFStrategies.newTab} pdfPlainData={props?.creditScoreNoticeDocument?.content || ('' as string)}>
          Click to see your credit score notice
        </ShowPdfLink>
      </CommonSection>
      <CommonSection>
        <AgreeButton dataAt="continue" onClick={handleSubmit}>
          Continue
        </AgreeButton>
      </CommonSection>
    </SApprovalTerms>
  );
};

export default ApprovalTerms;
